import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1024.000000 1024.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)">
		<path d="M3255 6233 c-357 -210 -666 -394 -707 -421 -25 -16 -45 -22 -60 -19
-13 4 -106 56 -208 117 -182 108 -208 122 -194 98 5 -7 3 -8 -5 -4 -7 5 -10
11 -7 14 8 7 -24 28 -261 168 -293 172 -295 174 -331 174 -46 0 -129 -45 -152
-83 -19 -31 -20 -56 -20 -924 l0 -891 28 -26 c39 -37 352 -227 363 -220 6 3 9
330 9 792 0 433 0 790 0 794 0 4 60 -31 133 -77 72 -46 205 -130 295 -187 90
-57 206 -131 259 -165 53 -35 97 -63 100 -63 2 0 45 26 96 58 51 32 118 73
150 91 37 21 55 36 47 41 -8 5 -7 9 5 13 9 4 13 3 10 -3 -12 -20 14 -9 96 41
98 61 328 195 481 283 l108 61 0 238 c0 130 -1 237 -2 236 -2 0 -106 -61 -233
-136z m-1820 97 c-3 -5 -12 -10 -18 -10 -7 0 -6 4 3 10 19 12 23 12 15 0z
m110 -8 c-3 -3 -11 0 -18 7 -9 10 -8 11 6 5 10 -3 15 -9 12 -12z m-189 -60 c0
-10 -6 -19 -13 -19 -16 0 -17 9 -1 25 15 15 14 15 14 -6z m2005 4 c-6 -8 -21
-16 -32 -19 -24 -6 -19 1 13 19 31 16 32 16 19 0z m-1701 -11 c33 -19 21 -19
-21 0 -19 8 -27 14 -19 14 8 0 26 -6 40 -14z m55 -33 c-3 -3 -11 0 -18 7 -9
10 -8 11 6 5 10 -3 15 -9 12 -12z m1530 -22 c-3 -5 -12 -10 -18 -10 -7 0 -6 4
3 10 19 12 23 12 15 0z m-1440 -30 c3 -6 -1 -7 -9 -4 -18 7 -21 14 -7 14 6 0
13 -4 16 -10z m1390 0 c-3 -5 -12 -10 -18 -10 -7 0 -6 4 3 10 19 12 23 12 15
0z m-1868 -312 c-1 -57 -3 -11 -3 102 0 113 2 159 3 103 2 -57 2 -149 0 -205z
m618 224 c-3 -3 -11 0 -18 7 -9 10 -8 11 6 5 10 -3 15 -9 12 -12z m1012 -56
c0 -8 -6 -12 -15 -9 -11 5 -11 7 0 14 7 5 13 9 14 9 0 0 1 -6 1 -14z m-932
-14 c-3 -3 -11 0 -18 7 -9 10 -8 11 6 5 10 -3 15 -9 12 -12z m120 -43 c50 -24
51 -25 30 -33 -8 -3 -14 -1 -12 5 1 5 -16 18 -38 28 -22 11 -37 20 -32 20 4 1
27 -8 52 -20z m714 -3 c-10 -9 -69 -36 -69 -32 0 7 52 35 64 36 5 0 7 -2 5 -4z
m-564 -94 c-3 -3 -11 0 -18 7 -9 10 -8 11 6 5 10 -3 15 -9 12 -12z m391 -7
c-11 -8 -24 -15 -30 -15 -5 0 -1 7 10 15 10 8 24 14 29 14 6 0 1 -6 -9 -14z
m622 -49 c-2 -1 -12 -8 -22 -16 -13 -10 -17 -10 -12 -2 4 7 2 12 -6 12 -10 0
-10 2 1 9 8 5 20 7 28 4 8 -3 13 -6 11 -7z m-1544 -12 c3 -8 2 -12 -4 -9 -6 3
-10 10 -10 16 0 14 7 11 14 -7z m836 6 c-8 -5 -19 -10 -25 -10 -5 0 -3 5 5 10
8 5 20 10 25 10 6 0 3 -5 -5 -10z m-775 -20 c3 -6 -1 -7 -9 -4 -18 7 -21 14
-7 14 6 0 13 -4 16 -10z m735 -4 c0 -2 -7 -7 -16 -10 -8 -3 -12 -2 -9 4 6 10
25 14 25 6z m-1233 -153 c-2 -21 -4 -4 -4 37 0 41 2 58 4 38 2 -21 2 -55 0
-75z m553 97 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4
11 -10z m158 -75 c4 -4 -4 -4 -17 0 -18 6 -22 4 -15 -6 6 -11 3 -10 -12 1 -10
8 -21 16 -23 17 -2 2 10 1 28 -1 17 -2 35 -7 39 -11z m982 -9 c0 -2 -7 -7 -16
-10 -8 -3 -12 -2 -9 4 6 10 25 14 25 6z m-975 -24 c-3 -3 -11 0 -18 7 -9 10
-8 11 6 5 10 -3 15 -9 12 -12z m69 -34 c-7 -11 3 -10 29 3 21 10 21 10 3 -5
-24 -19 -27 -19 -50 -3 -16 12 -16 13 3 13 11 0 17 -4 15 -8z m-787 -350 c-1
-68 -3 -15 -3 117 0 132 2 187 3 123 2 -64 2 -172 0 -240z m1593 345 c0 -1 -8
-7 -18 -12 -13 -7 -19 -6 -19 2 0 7 9 13 19 13 10 0 18 -1 18 -3z m-690 -73
c8 -5 12 -11 10 -14 -3 -2 -14 2 -24 10 -22 15 -10 19 14 4z m60 -14 c0 -2 -7
-6 -15 -10 -8 -3 -15 -1 -15 4 0 6 7 10 15 10 8 0 15 -2 15 -4z m466 -11 c-11
-8 -24 -15 -30 -15 -5 0 -1 7 10 15 10 8 24 14 29 14 6 0 1 -6 -9 -14z m-461
-15 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z
m374 -33 c-2 -1 -13 -9 -24 -17 -19 -14 -19 -14 -6 3 7 9 18 17 24 17 6 0 8
-1 6 -3z m-74 -45 c-3 -3 -11 0 -18 7 -9 10 -8 11 6 5 10 -3 15 -9 12 -12z
m-112 -41 c4 -1 15 -1 25 -1 16 -1 16 -1 0 -11 -13 -7 -24 -5 -43 7 -28 19
-34 29 -7 15 9 -5 20 -9 25 -10z m-1156 -698 c-1 -59 -3 -13 -3 102 0 116 2
164 3 108 2 -56 2 -151 0 -210z m0 -165 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3
-3 4 -12 1 -19z m39 -20 c4 -7 3 -8 -4 -4 -16 10 -15 -6 1 -24 6 -8 2 -6 -11
5 -17 14 -19 21 -10 27 16 10 16 10 24 -4z m114 -99 c17 -13 18 -17 5 -10 -33
17 -51 31 -40 31 6 0 21 -10 35 -21z m111 -70 l24 -20 -30 17 c-39 24 -40 24
-28 24 6 0 21 -9 34 -21z"/>
<path d="M3415 5651 c-33 -21 -139 -84 -235 -141 -96 -56 -213 -126 -260 -155
-47 -29 -173 -106 -282 -172 l-196 -120 -79 47 c-43 26 -149 91 -237 144 -87
53 -162 96 -167 96 -5 0 -9 -98 -9 -223 l0 -222 230 -138 c149 -89 240 -137
258 -137 15 0 50 14 78 32 46 29 94 59 433 267 73 46 140 85 147 88 12 4 14
-46 13 -303 l0 -309 -172 -102 c-274 -163 -521 -313 -539 -330 -11 -10 -18
-31 -18 -55 0 -32 5 -41 33 -59 55 -35 98 -22 270 84 159 98 528 324 681 417
51 32 97 67 108 85 17 28 18 65 18 638 0 334 -3 607 -7 606 -5 0 -35 -17 -68
-38z"/>
<path d="M6002 5550 c-160 -34 -280 -169 -301 -338 -31 -246 114 -441 351
-474 116 -16 256 18 355 85 l33 22 0 183 0 182 -170 0 -170 0 0 -75 0 -75 85
0 85 0 0 -66 c0 -64 0 -65 -33 -79 -131 -55 -272 -12 -329 99 -30 58 -37 181
-13 242 53 139 197 183 347 105 l62 -32 56 56 55 56 -38 33 c-56 50 -136 77
-242 81 -49 2 -109 0 -133 -5z"/>
<path d="M3900 5150 l0 -400 90 0 90 0 0 253 0 252 41 -80 c77 -151 182 -315
201 -315 10 0 18 4 18 8 0 4 17 35 39 68 21 32 68 113 104 179 37 66 70 126
75 134 5 8 6 -99 4 -242 l-5 -257 92 0 91 0 0 400 0 400 -93 0 -92 0 -91 -152
c-51 -84 -102 -172 -115 -195 -26 -47 -34 -51 -43 -25 -4 9 -55 97 -113 195
l-106 177 -94 0 -93 0 0 -400z"/>
<path d="M4892 5273 c3 -243 6 -286 23 -338 49 -148 211 -228 396 -195 118 22
197 80 243 179 19 43 21 68 26 339 l5 292 -92 0 -93 0 0 -258 c0 -247 -1 -260
-22 -302 -28 -54 -73 -80 -141 -80 -63 0 -120 29 -141 74 -14 29 -16 74 -16
300 l0 266 -96 0 -96 0 4 -277z"/>
<path d="M6813 5533 c-3 -10 -12 -34 -20 -53 -8 -19 -38 -98 -68 -175 -41
-108 -173 -446 -212 -542 -4 -10 19 -13 94 -13 l99 0 24 75 24 75 157 0 158 0
28 -75 28 -75 98 0 c90 0 99 2 93 18 -4 9 -45 114 -91 232 -46 118 -113 289
-148 380 l-63 165 -97 3 c-86 2 -98 1 -104 -15z m151 -335 c25 -70 46 -132 46
-138 0 -12 -187 -14 -193 -2 -4 7 93 275 98 270 2 -2 24 -60 49 -130z"/>
<path d="M7420 5150 l0 -400 90 0 91 0 -3 250 c-2 138 -2 250 -1 250 2 0 19
-33 39 -72 38 -78 143 -257 173 -297 11 -14 25 -22 33 -18 16 6 126 186 197
320 l41 79 0 -256 0 -256 90 0 90 0 0 400 0 400 -94 0 -95 0 -94 -157 c-52
-87 -103 -175 -113 -195 -10 -21 -20 -38 -23 -38 -3 0 -58 87 -121 193 l-115
192 -92 3 -93 3 0 -401z"/>
<path d="M8642 5473 c-17 -43 -67 -172 -112 -288 -66 -171 -129 -331 -167
-422 -4 -10 19 -13 94 -13 l99 0 26 73 25 72 159 3 159 2 24 -75 25 -75 98 0
c54 0 98 2 98 5 0 3 -56 148 -124 323 -68 174 -136 352 -152 394 l-29 78 -97
0 -96 0 -30 -77z m176 -281 c27 -72 47 -134 44 -137 -3 -3 -47 -5 -99 -5 -68
0 -93 3 -93 13 0 16 92 268 96 264 2 -2 26 -62 52 -135z"/>
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
